import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { DivisionsTableDefinitionZod } from '../tables';

type Arguments = {
    corporationId: string;
    position?: number;
};

export const schemaDivisionResolver_List = z.array(DivisionsTableDefinitionZod);

export type SchemaDivisionResolver_List = z.infer<typeof schemaDivisionResolver_List>;

export type DivisionResolver_List = Resolver<Arguments, SchemaDivisionResolver_List>;
